<template>
  <el-select
    :clearable="true"
    size="small"
    v-model="val"
    :placeholder="placeholder"
    @change="onChange"
    @clear="onClear"
  >
    <el-option
      v-for="(item, index) in listFilter(dataList)"
      :key="index"
      :label="`${item[props.label]}`"
      :value="`${item[props.value]}`"
      :disabled="item.disabled"
    />
  </el-select>
</template>

<script>
import apis from '@/utils/apis';

const dataList = [];
let hasFetch = false;

export default {
  name: '',
  mixins: [],
  components: {

  },
  props: {
    dataFilter: Function,
    filterOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    value: [String, Number],
    placeholder: String,
    props: {
      type: Object, // 选项配置
      default() {
        return { label: 'name', value: 'value' };
      },
    },
  },
  data() {
    return {
      dataList,
      url: 'partList',
      val: '',
    };
  },
  computed: {
  },
  watch: {
    value(val) {
      this.val = val;
    }
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onClear: function () {
      this.$emit('clear');
    },
    onChange() {
      this.$emit('input', this.val);
      const item = this.dataList.find(t => `${t[this.props.value]}` === `${this.val}`);
      this.$emit('change', item);
    },
    // 数据过滤
    listFilter(list) {
      if (!this.dataFilter) {
        return list;
      }
      return this.dataFilter(list, this.filterOptions);
    },
    init() {
      this.val = this.value;
      if (!hasFetch) {
        hasFetch = true;
        this.fetchData();
      }
    },
    fetchData() {
      this.$getJSON(apis[this.url]).then((res) => {
        const list = res.data || [];
        this.dataList = list;
      });
    }
  },
  created() {
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
